import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/hooks/useRemoveDialog.tsx";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Button } from '@mui/material';
import React from 'react';
import { Dialog } from '@gmini/ui-kit/lib/Dialog';
import { DialogActions } from '@gmini/ui-kit/lib/DialogActions';
import { DialogContent } from '@gmini/ui-kit/lib/DialogContent';
import { DialogContentText } from '@gmini/ui-kit/lib/DialogContentText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function useRemoveDialog(onRemove) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      toRemoveNode = _React$useState2[0],
      setToRemoveNode = _React$useState2[1];

  var handleRemove = React.useCallback(function () {
    if (toRemoveNode && onRemove) {
      onRemove(toRemoveNode);
    }

    setToRemoveNode(null);
  }, [onRemove, toRemoveNode]);
  var RemoveDialog = React.useMemo(function () {
    var DialogR = /*#__PURE__*/_jsxs(Dialog, {
      open: !!toRemoveNode,
      onClose: function onClose() {
        return setToRemoveNode(null);
      },
      children: [/*#__PURE__*/_jsx(DialogContent, {
        children: /*#__PURE__*/_jsxs(DialogContentText, {
          id: "alert-dialog-description",
          children: ["\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 ", /*#__PURE__*/_jsx("strong", {
            children: toRemoveNode === null || toRemoveNode === void 0 ? void 0 : toRemoveNode.title
          })]
        })
      }), /*#__PURE__*/_jsxs(DialogActions, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: handleRemove,
          color: "primary",
          autoFocus: true,
          "data-test-id": "confirmDelete",
          children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return setToRemoveNode(null);
          },
          color: "primary",
          "data-test-id": "cancelDelete",
          children: "\u041E\u0442\u043C\u0435\u043D\u0430"
        })]
      })]
    });

    return DialogR;
  }, [handleRemove, toRemoveNode]);
  return {
    RemoveDialog: RemoveDialog,
    setToRemoveNode: setToRemoveNode
  };
}